import React, { Component, createRef } from 'react';
import { Input, List, Label, Grid, Button, Icon, Checkbox, Dropdown } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import fuzzysort from 'fuzzysort';
import axios from 'axios';
import { API_URL } from '../App.js';
// import { YugtunLoader, WordItem, TagColors } from './HomeHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';
import Citation from './Citation.js'

// import { dialogueGenerator } from './constants/dialogueListGenerator.js';
//test

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

const frontlacingpattern = [
  { key: '0', text: '0 Cross (Radial)', value: 0 },
  { key: '1', text: '1 Cross', value: 1 },
  { key: '2', text: '2 Cross', value: 2 },
  { key: '3', text: '3 Cross', value: 3 },
  { key: '4', text: '4 Cross', value: 4 },
]

const rearlacingpattern = [
  { key: '0', text: '0 Cross (Radial)', value: 0 },
  { key: '1', text: '1 Cross', value: 1 },
  { key: '2', text: '2 Cross', value: 2 },
  { key: '3', text: '3 Cross', value: 3 },
  { key: '4', text: '4 Cross', value: 4 },
]

class Home extends Component {
	constructor(props) {
		super(props);
    // console.log(props,props.location.state.currentCategory !== 'all')
		this.state = {

      parseIndex:0,
      playingAudio: false,
      prevSearch: [],
      prevWordsList: [],
      logoup:false,
      wfront: 33, //flange to center
      pcdfront: 45,
      d2front: 2.5, //spoke hole diameter
      spokesfront: 36,
      erdfront: -1,
      lacingpatternfront:-1,
      spokelengthfront:'?',
      wrear: 31.5, //flange to center
      pcdrear: 51.5,
      d2rear: 2.5, //spoke hole diameter
      spokesrear: 36,
      erdrear: -1,
      lacingpatternrear:-1,
      spokelengthrear:'?',
      spokelengthlocked:false,
      showMasterSpecs:false,
		}

	}

  componentDidUpdate(prevProps, prevState) {
    if (this.state.erdrear !== prevState.erdrear || this.state.lacingpatternrear !== prevState.lacingpatternrear || this.state.erdfront !== prevState.erdfront || this.state.lacingpatternfront !== prevState.lacingpatternfront) {
      this.setState({spokelengthlocked:false, spokelengthrear:'?', spokelengthfront:'?'})
    }
  }


  calculateSpokeLength = () => {
    var spokelengthfront = Math.sqrt(((this.state.wfront)**2)+((this.state.pcdfront/2)**2)+((this.state.erdfront/2)**2)-(2*(this.state.pcdfront/2)*(this.state.erdfront/2)*Math.cos(((720*this.state.lacingpatternfront)*(Math.PI/180))/this.state.spokesfront)))-(this.state.d2front/2)
    var spokelengthrear = Math.sqrt(((this.state.wrear)**2)+((this.state.pcdrear/2)**2)+((this.state.erdrear/2)**2)-(2*(this.state.pcdrear/2)*(this.state.erdrear/2)*Math.cos(((720*this.state.lacingpatternrear)*(Math.PI/180))/this.state.spokesrear)))-(this.state.d2rear/2)
    if (this.state.erdrear == -1 || this.state.lacingpatternrear == -1) {
      spokelengthrear = '?'
    } else {
      this.setState({spokelengthrear:spokelengthrear.toFixed(1)})      
    }
    if (this.state.erdfront == -1 || this.state.lacingpatternfront == -1) {
      spokelengthfront = '?'
    } else {
      this.setState({spokelengthfront:spokelengthfront.toFixed(1)})
    }
    this.setState({spokelengthlocked:true})
  }

  handleChangeFront = (e, data) => {
    console.log(e, data)
    this.setState({erdfront:Number(data.value)})
  }

  handleSortChangeFront = (e, {value}) => {
    if (value === 0 && this.state.sortValue !== 0) {
      this.setState({lacingpatternfront: 0})
    } else if (value === 1 && this.state.sortValue !== 1) {
      this.setState({lacingpatternfront: 1})
    } else if (value === 2 && this.state.sortValue !== 2) {
      this.setState({lacingpatternfront: 2})
    } else if (value === 3 && this.state.sortValue !== 3) {
      this.setState({lacingpatternfront: 3})
    } else if (value === 4 && this.state.sortValue !== 4) {
      this.setState({lacingpatternfront: 4})
    }
  } 


  handleChangeRear = (e, data) => {
    // console.log(e, d)
    this.setState({erdrear:Number(data.value)})
  }

  handleSortChangeRear = (e, {value}) => {
    if (value === 0 && this.state.sortValue !== 0) {
      this.setState({lacingpatternrear: 0})
    } else if (value === 1 && this.state.sortValue !== 1) {
      this.setState({lacingpatternrear: 1})
    } else if (value === 2 && this.state.sortValue !== 2) {
      this.setState({lacingpatternrear: 2})
    } else if (value === 3 && this.state.sortValue !== 3) {
      this.setState({lacingpatternrear: 3})
    } else if (value === 4 && this.state.sortValue !== 4) {
      this.setState({lacingpatternrear: 4})
    }
  } 


	render() {
    console.log(this.state)

		return (
      <div>
        <div style={{fontSize:'28px', textAlign:'center',lineHeight:'36px'}}>Spoke Length Calculator for Master 64 Hubs</div>
  			<div style={{fontFamily:'Rubik',fontSize:'18px',fontWeight:300, maxWidth:450}} className="app">
          <div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
            <div style={{maxWidth:400}}>
            <div>
              <div style={{marginBottom:15, marginTop:25,textDecoration:'underline',fontWeight:'500'}}>Front Wheel:</div>

              <div style={{marginBottom:15}}><span>Effective Rim Diameter (ERD):</span> 
                {window.innerWidth < 480 ?
                <div><Input type='number' style={{width:'110px',marginTop:10}} onChange={this.handleChangeFront} /><span> mm </span></div>
                :
                <span><Input type='number' style={{width:'110px',marginLeft:5}} onChange={this.handleChangeFront} /><span> mm </span></span>
                }

              </div>
              <div><span>Lacing Pattern:</span> 
                {window.innerWidth < 480 ?
                <Dropdown style={{marginTop:10}} selection scrolling='false' placeholder='Choose Lacing Pattern' options={frontlacingpattern} value={this.state.sortValueFront} onChange={this.handleSortChangeFront} />
                :
                <Dropdown style={{marginLeft:5}} selection scrolling='false' placeholder='Choose Lacing Pattern' options={frontlacingpattern} value={this.state.sortValueFront} onChange={this.handleSortChangeFront} />
                }          
              </div>
              
            </div>
            <div style={{paddingTop:10}}>
              <div style={{marginBottom:15, marginTop:25,textDecoration:'underline',fontWeight:'500'}}>Rear Wheel:</div>


              <div style={{marginBottom:15}}><span>Effective Rim Diameter (ERD):</span> 
                {window.innerWidth < 480 ?
                <div><Input type='number' style={{width:'110px',marginTop:10}} onChange={this.handleChangeRear} /><span> mm </span></div>
                :
                <span><Input type='number' style={{width:'110px',marginLeft:5}} onChange={this.handleChangeRear} /><span> mm </span></span>
                }          
              </div>
              <div><span>Lacing Pattern:</span>
                {window.innerWidth < 480 ?
                <Dropdown style={{marginTop:10}} selection scrolling='false'placeholder='Choose Lacing Pattern' options={rearlacingpattern} value={this.state.sortValueRear} onChange={this.handleSortChangeRear} />
                :
                <Dropdown style={{marginLeft:5}} selection scrolling='false'placeholder='Choose Lacing Pattern' options={rearlacingpattern} value={this.state.sortValueRear} onChange={this.handleSortChangeRear} />
                }  
              </div>
            </div>

              <Button disabled={this.state.spokelengthlocked} style={{marginTop:35,marginBottom:25,fontSize:'18px'}} onClick={()=>this.calculateSpokeLength(this.state.rimradius,this.state.lacingpattern)}> Calculate </Button>
              
              <div style={{border:'10px solid #e6d07e',padding:15, marginBottom:35, maxWidth:'380px',}}>
                <div style={{fontWeight:300, fontSize:'22px'}}>Front Spoke Length: {this.state.spokelengthfront} mm</div>
                <div style={{paddingTop:'15px',fontWeight:300, fontSize:'22px'}}>Rear Spoke Length: {this.state.spokelengthrear} mm</div>
              </div>

              {this.state.showMasterSpecs ?
                <div>
                  <div style={{cursor:'pointer',color:'#bfbfbfde'}} onClick={()=>{this.setState({showMasterSpecs:false})}}>
                        <span style={{lineHeight:'20px',marginRight:'10px'}}>{"Hide Master 64 Hub Specs"}</span>
                        <Icon name='chevron up' />
                  </div>
                  <div style={{display:'flex',flexDirection:'row',color:'grey',alignItems:'center',margin:"20px 0px"}}>
                    <div>
                      <div style={{textDecoration:'underline',paddingBottom:5}}>Master 64 Front Hub:</div>
                      <div>Flange To Center: {this.state.wfront} mm</div>
                      <div>Hub Flange Diameter (PCD) ø: {this.state.pcdfront} mm </div>
                      <div>Spoke Hole Diameter: {this.state.d2front} mm</div>
                      <div>Number of Spokes: 36</div>
                    </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',color:'grey',alignItems:'center',margin:"20px 0px"}}>
                    <div>
                      <div style={{textDecoration:'underline',paddingBottom:5}}>Master 64 Rear Hub:</div>
                      <div>Flange To Center: {this.state.wrear} mm</div>
                      <div>Hub Flange Diameter (PCD) ø: {this.state.pcdrear} mm </div>
                      <div>Spoke Hole Diameter: {this.state.d2rear} mm</div>
                      <div>Number of Spokes: 36</div>
                    </div>
                  </div>
                </div>
                :
                <div style={{cursor:'pointer',color:'#bfbfbfde'}} onClick={()=>{this.setState({showMasterSpecs:true})}}>
                      <span style={{lineHeight:'20px',marginRight:'10px'}}>{"Show Master 64 Hub Specs"}</span>
                      <Icon name='chevron down' />
                </div>
              }
            </div>
          </div>
  			</div>
      </div>
		);
	}
}
export default Home;